//
// MapPin.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../core/GTLModel";
import "../../core/SelectionMode";
import "@sas-dvr/ltjs-commons/maps/VisibleState";
import "./MapPinType";
import "@sas-dvr/ltjs-commons/maps/GeoEnrichmentResult";
import "@sas-dvr/ltjs-commons/maps/RouteInfo";

var MapPin = createModule("gtl_MapPin", [130,13,20148,20275], EventDispatcher, [
    {
        REVERSE_GEOCODE_COMPLETE: 30074,
        ROUTING_COMPLETE: 30073,
        GEO_ENRICHMENT_COMPLETE: 30072,
        BUFFER_COMPLETE: 30071,
    },
    ,
    ,
    {
        country: 7,
        displayState: 4,
        address: 7,
        color: 10,
        latLon: 11,
        name: 7,
        esriToken: 7,
        description: 7,
        selectionMode: 4,
        pixelLocation: 11,
    },
    {
        createRouteFromPoint: [0,11,2,1],
        select: [0,2],
        getRouteInfo: [1],
        convertToCustom: [0],
        setAddressFromReverseGeocode: [0],
        createBuffer: [0,1,4],
        hideRoute: [0],
        hideBuffer: [0],
        createRouteToPoint: [0,11,2,1],
        showRoute: [0],
        enrichBuffer: [0,[7]],
        getRoutePins: [[1]],
        isSelected: [2],
        getBufferInfo: [1],
        hasRoute: [2],
        createMultiPointRoute: [0,[1],1],
        hasSelection: [2],
        showBuffer: [0],
        getGeoEnrichmentData: [7],
        getGeoEnrichmentResults: [[1]],
        deleteBuffer: [0],
        getType: [4],
        hasBuffer: [2],
        createRoute: [0,1,1],
        deleteRoute: [0],
    },
    ,
    ,
]);
export default MapPin;
